import { CoObjectItem } from "../interfaces/CoObject";
import React, { useEffect } from "react";
import {
  DocPropKeys,
  getDocumentPartMetadataFromCustomXml,
  retrieveDocumentProp,
} from "../../utils/helpers/CustomXmlHelper";
import LoadingManager from "../../common/loading/LoadingManager";
import { RETRIEVE_DOCUMENT_DATA_NOTIFICATION } from "../../utils/constants/notification";
import { DocumentPartMetadata } from "../../api/models/document-part-metadata";
import { fetchDocumentPartDetails } from "../../api/document/DocumentsPart";
import { DocumentPart } from "../../api/models";

export interface CoRetrieveDocumentDataStateProps {
  shouldFetchDocumentPart?: boolean;
  shouldFetchDocumentPartMetadata?: boolean;
  isSilent?: boolean;
  children: (data: {
    coObject: CoObjectItem;
    documentPart?: DocumentPart;
    documentPartMetadata?: DocumentPartMetadata;
  }) => React.JSX.Element;
}

interface CoRetrieveDocumentDataState {
  loading?: boolean;
  failed: boolean;
  coObject?: CoObjectItem;
  documentId?: string;
  documentPart?: DocumentPart;
  documentPartMetadata?: DocumentPartMetadata;
}

const CoRetrieveDocumentDataInitialState = {
  failed: false,
};

export const CoRetrieveDocumentData = (props: CoRetrieveDocumentDataStateProps) => {
  const [state, setState] = React.useState<CoRetrieveDocumentDataState>(CoRetrieveDocumentDataInitialState);
  const { coObject, documentPart, documentPartMetadata } = state;
  const { shouldFetchDocumentPart, shouldFetchDocumentPartMetadata } = props;

  const fetchDocumentData = async () => {
    if (!props.isSilent) LoadingManager.create(RETRIEVE_DOCUMENT_DATA_NOTIFICATION);
    try {
      const documentId = await retrieveDocumentProp(DocPropKeys.DocumentId);
      console.log(`Retrieve documentPart for document: ${documentId}`);
      const documentPart =
        shouldFetchDocumentPart && documentId
          ? await fetchDocumentPartDetails(documentId, {
              params: { notShowLoading: true },
            })
          : undefined;

      let documentPartMetadata: DocumentPartMetadata = undefined;
      if (shouldFetchDocumentPartMetadata) {
        console.log(`Retrieve documentPartMetadata`);
        documentPartMetadata = await getDocumentPartMetadataFromCustomXml();
      }

      setState({
        ...state,
        documentId: documentId,
        documentPart: documentPart,
        documentPartMetadata: documentPartMetadata,
        coObject: { documentId: documentId } as CoObjectItem,
        loading: false,
      });
    } catch (error) {
      console.error(error);
      setState({ ...state, loading: false, failed: true });
      LoadingManager.remove(RETRIEVE_DOCUMENT_DATA_NOTIFICATION);
    }
  };

  useEffect(() => {
    fetchDocumentData();
  }, []);

  useEffect(() => {
    if (coObject) {
      LoadingManager.remove(RETRIEVE_DOCUMENT_DATA_NOTIFICATION);
    }
  }, [coObject]);

  if (coObject) {
    return props.children({
      coObject,
      documentPart,
      documentPartMetadata,
    });
  }
  //TODO handle failure verbose
  return null;
};
